import * as React from "react";
import {connect} from "react-redux";
import {database, storage} from "../../../firebase";
import {
  campaignCurrentlyEditingImageAction,
  removeImageForCurrentlyEditingCampaign
} from "../CampaignOperation";

export interface CampaignUploadInputProps {
  campaign: any;
  setImageForCurrentlyEditingCampaign: (image: any) => void;
  removeImage: () => void;
}

class CampaignUploadInputComponent extends React.Component<CampaignUploadInputProps> {
  private storageRef: any;

  constructor(props) {
    super(props);
    this.storageRef = storage.ref("/charity-images");
  }

  render() {
    const {
      campaign
    } = this.props;
    let logoImgUrl,
      logoImgName,
      mobileLogoImgUrl,
      mobileLogoImgName;
    if (campaign) {
      logoImgUrl = campaign.logoImgUrl;
      logoImgName = campaign.logoImgName;
      mobileLogoImgUrl = campaign.mobileLogoImgUrl;
      mobileLogoImgName = campaign.mobileLogoImgName;
    }
    return (
      <div style={{display: 'flex', justifyContent:'space-between', paddingTop: 40}}>
      <div style={{width: '48%'}}>
        <h4 className="subtitle">Main Logo</h4>
        <div className="field">
          {
            logoImgUrl &&
            <div>
              <figure className="image is-128x128">
                <img src={logoImgUrl}/>
              </figure>
            </div>
          }
          <div className="is-clearfix">
            <label className="file-label is-pulled-left">
              <input
                className="file-input"
                onChange={this.handleFileUpload}
                type="file"
                name="logoImgUrl"
              />
              <span className="file-cta">
            <span className="file-icon">
              <i className="fa fa-upload"/>
            </span>
            <span className="file-label">
              Choose a file...
            </span>
          </span>
            </label>
            {
              logoImgName &&
              <div className="control is-pulled-left">
                &nbsp; <a className="button is-danger" onClick={this.handleFileRemoval(logoImgName)}>Delete Image</a>
              </div>
            }
          </div>
        </div>
        </div>
        <div style={{width: '48%'}}>
        <h4 className="subtitle">Mobile Secondary Logo</h4>
        <div className="field">
          {
            mobileLogoImgUrl &&
            <div>
              <figure className="image is-128x128">
                <img src={mobileLogoImgUrl}/>
              </figure>
            </div>
          }
          <div>
            <label className="file-label is-pulled-left">
              <input
                className="file-input"
                onChange={this.handleFileUpload}
                type="file"
                name="mobileLogoImgUrl"
              />
              <span className="file-cta">
            <span className="file-icon">
              <i className="fa fa-upload"/>
            </span>
            <span className="file-label">
              Choose a file...
            </span>
          </span>
            </label>
            {
              mobileLogoImgName &&
              <div className="control is-pulled-left">
                &nbsp; <a className="button is-danger" onClick={this.handleFileRemoval(mobileLogoImgName)}>Delete Image</a>
              </div>
            }
          </div>
        </div>
      </div>
      </div>
    )
  }

  handleFileUpload = (event: any) => {
    const file = event.target.files[0];
    const imageName = event.target.name;
    const {setImageForCurrentlyEditingCampaign} = this.props;
    if (!file) {
      return;
    }
    const uploadTask = storage.ref("/charity-images").child(file.name)
      .put(file, {contentType: file.type});

    uploadTask.then((snapshot) => {
      const imgNameKey = imageName === "mobileLogoImgUrl" ?
        "mobileLogoImgName" : "logoImgName";
      const imageDetails = {
        [imageName]: snapshot.downloadURL,
        [imgNameKey]: file.name
      };
      setImageForCurrentlyEditingCampaign(imageDetails);
    });
  }

  handleFileRemoval = (logoImgName: string) => {
    return () => {
      const {removeImage} = this.props;
      this.storageRef.child(logoImgName).delete().then(() => {
        removeImage();
      });
    };
  }
}

const mapStateToProps = ({campaigns}) => ({
  campaign: campaigns.imageDetails
});

const mapDispatchToProps = (dispatch) => ({
  setImageForCurrentlyEditingCampaign: (image) => dispatch(campaignCurrentlyEditingImageAction(image)),
  removeImage: () => dispatch(removeImageForCurrentlyEditingCampaign()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignUploadInputComponent) as any;
